import { CARD_TYPE } from '../Card/Card.types';

import type { HTMLAttributes, ReactElement } from 'react';
import type { CardProps } from '../Card/Card.types';
import type { EventCardProps } from '../EventCard/EventCard.types';

export const DISPLAY_TYPE = {
  GRID: 'grid',
  CAROUSEL: 'carousel',
  STACK: 'stack',
} as const;

export interface CardsProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Data to be displayed in the cards as Card or EventCard
   */
  data?: CardProps[] | EventCardProps[];

  /**
   * Any children to be rendered in the cards
   */
  children?: ReactElement | ReactElement[];

  /**
   * Columns to display
   */
  columnCount?: number;

  /**
   * Sets the first element to be active
   */
  isFirstElementActive?: boolean;

  /**
   * Sets the data-testid attribute
   */
  testid?: string;

  /**
   * Sets the card type
   */
  type?: typeof CARD_TYPE[keyof typeof CARD_TYPE];

  /**
   * Sets the display type
   */
  display?: typeof DISPLAY_TYPE[keyof typeof DISPLAY_TYPE];
}
